import { forwardRef } from 'react';

import { TOKEN_ELEMENT_MAP } from 'styles/config/text';

import * as Styled from './Text.styled';
import type { Props } from './types';

const Text = forwardRef<
  HTMLElement,
  Omit<React.HTMLProps<HTMLElement>, keyof Props> & Props
>(
  (
    {
      as: customAs,
      children,
      variant = 'body',
      align,
      color,
      decoration,
      decorationColor,
      font,
      fontStyle,
      letterSpacing,
      lineHeight,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      size,
      textTransform,
      weight,
      whiteSpace,
      ...rest
    },
    ref,
  ) => {
    const as = (customAs ||
      TOKEN_ELEMENT_MAP[variant]) as keyof React.JSX.IntrinsicElements;

    return (
      <Styled.Text
        ref={ref}
        $align={align}
        $color={color}
        $decoration={decoration}
        $decorationColor={decorationColor}
        $font={font}
        $fontStyle={fontStyle}
        $letterSpacing={letterSpacing}
        $lineHeight={lineHeight}
        $margin={margin}
        $marginBottom={marginBottom}
        $marginLeft={marginLeft}
        $marginRight={marginRight}
        $marginTop={marginTop}
        $padding={padding}
        $paddingBottom={paddingBottom}
        $paddingLeft={paddingLeft}
        $paddingRight={paddingRight}
        $paddingTop={paddingTop}
        $size={size}
        $textTransform={textTransform}
        $variant={variant}
        $weight={weight}
        $whiteSpace={whiteSpace}
        as={as}
        {...rest}
      >
        {children}
      </Styled.Text>
    );
  },
);

Text.displayName = 'Text';

export default Text;
